function Hi(t) {
    if (t._textWidth || (t._textWidth = t.textWidth || 50,
    t._fontSize = t.fontSize || 12),
    t.textWidth = t.rect.width,
    t.textWidth = t.textWidth,
    t.unit || (t.unit = "%"),
    t.sliderWidth || (t.sliderWidth = t.width),
    t.sliderHeight || (t.sliderHeight = t.height),
    !t.rect)
        return;
    const e = t.rect.width / t.sliderWidth
      , i = t.rect.height / t.sliderHeight
      , o = Math.min(e, i);
    t.fontSize = t._fontSize * o;
    const s = t.rect.width - t._textWidth * o;
    t.textLeft = s + 10 * o;
    t.barRect = {
        x: 0,
        y: (t.rect.height - t.barHeight * i) / 2,
        width: s,
        height: t.barHeight * i
    };
    St(t.barRect);
    Lo(t)
}
function Lo(t) {
    const e = t.barRect.height * 3.5, i = t.barRect.width * t.value / 100;
    t.ballRect = {
        x: i,
        y: (t.rect.height - e) / 2,
        width: e,
        height: e
    };
     St(t.ballRect);
     var unit="%";
     if(t.data&&t.data.length>0){
        if(t.data[0].key=="unit"){
            unit=t.data[0].value;
        }
     }
     t.text = t.value + unit;
     ve(t)
}

function ve(t) {
    var e=t.paddingTop,i=t.paddingBottom,o=t.paddingLeft,s=t.paddingRight,r=t.rect,n=t.canvas;
    var l=t.textLeft,a=t.textTop,c=t.textWidth,h=t.textHeight;
    var u = o;
    var d = e;
    l && Math.abs(l) < 1 && (l *= r.width), a && Math.abs(a) < 1 && (a *= r.height);
    const v = r.width - o - s - (l || 0), m = r.height - e - i - (a || 0);
    c && c < 1 && (c *= r.width), h && h < 1 && (h *= r.height), u += (l || 0) + r.x, d += (a || 0) + r.y;
    const g = t.textAlign || n.store.options.textAlign, p = t.textBaseline || n.store.options.textBaseline;
    switch (g) {
        case "center":
            u += (v - (c || v)) / 2;
            break;
        case "right":
            u += v - (c || v);
            break
    }
    switch (p) {
        case "middle":
            d += (m - (h || m)) / 2;
            break;
        case "bottom":
            d += m - (h || m);
            break
    }
    const b = {
        x: u,
        y: d,
        width: c || v,
        height: h || m
    };
    St(b), t.textRect = b, Ne(t)
}
function St(t) {
    t.ex = t.x + t.width, t.ey = t.y + t.height
}
/*function dn(t, e) {
    const i = e.x - t.rect.x;
    if (i > t.barRect.width) return;
    let o = Math.round(i / t.barRect.width * 100);
    o < t.min || o > t.max || o < 0 || o > 100 || (t.value = o, Lo(t), t.text = t.value + t.unit, ve(t), t.canvas.store.emitter.emit("valueUpdate", t), t.canvas.render())
}*/
function dn(t, e) {
    const i = e.x - t.rect.x;
    if (i > t.barRect.width)
        return;
    let o = Math.round(i / t.barRect.width * 100);
    o < t.min || o > t.max || o < 0 || o > 100 || (t.value = o,
    Lo(t),
    t.text = t.value + t.unit,
    ve(t),
    t.canvas.store.emitter.emit("valueUpdate", t),
    t.canvas.render())
}
function Ne(t, e = t.text) {
    if (e == null) {
        t.textLines = [];
        return
    }
    e = e.toString();
    let i = [];
    const o = t.fontSize * t.lineHeight, s = t.textRect.height, r = Math.floor(s / o), n = r > 1 ? r : 1;
    switch (t.whiteSpace) {
        case "nowrap":
            if (t.ellipsis !== !1) {
                const h = vs(e.split(""), t);
                i.push(h[0]), h.length > 1 && Ni(i)
            } else i.push(e);
            break;
        case "pre-line":
            i = e.split(/[\n]/g), t.ellipsis !== !1 && i.length > n && (i = i.slice(0, n), Ni(i));
            break;
        case "break-all":
        default:
            const a = e.split(/[\n]/g);
            let c = 0;
            for (const h of a) {
                const u = t.whiteSpace === "break-all" ? h.split("") : br(h);
                let d =  [""];//vs(u, t);
                if (d.length === 0 && (d = [""]), t.ellipsis != !1)
                    for (const v of d)
                        if (c++, c > n) {
                            Ni(i);
                            break;
                        } else {
                            i.push(v);
                        }
                        else {
                            i.push(...d);
                        }
            }
            break
    }
    const l = t.keepDecimal;
    return l != null && i.forEach(function(a1, c){
        const h = Number(a1);
        isNaN(h) || (i[c] = h.toFixed(l))
    }), t.textLines = i, i
}
function Ni(t) {
    t[t.length - 1] = t[t.length - 1].slice(0, -3) + "..."
}
function br(t = "") {
    const e = [];
    let i = "";
    for (let o = 0; o < t.length; ++o) {
        const s = t.charCodeAt(o);
        s < 33 || s > 126 ? (i && (e.push(i), i = ""), e.push(t[o])) : i += t[o]
    }
    return i && e.push(i), e
}

function vs(t, e) {
    var i = e.canvas;
    var  o = i.getContext("2d"); 
    var s=e.fontStyle;
    var r=e.fontWeight;
    var n=e.fontSize;
    var l=e.fontFamily;
    var a=e.lineHeight;
    o.save();
    const c = [];
    let h = t[0] || "";
    for (let u = 1; u < t.length; ++u) {
        const d = t[u] || "", v = h + d;
        let m = 0;
        if (i.store.options.measureTextWidth) o.font = Ti({
            fontStyle: s,
            fontWeight: r,
            fontFamily: l || i.store.options.fontFamily,
            fontSize: n,
            lineHeight: a
        }), m = o.measureText(v).width;
        else {
            const p = v.match(/[^\x00-\xff]/g) || "", b = p.length * n, k = v.match(/\s/g) || "", P = k.length * n * .3, _ = (v.length - p.length - k.length) * n * .6;
            m = b + P + _
        }
        const g = e.rect.width;
        m <= g ? h += d : (h.length && c.push(h), h = d)
    }
    return h.length && c.push(h), o.restore(), c
}
function Ti({
    fontStyle: t = "normal",
    textDecoration: e = "normal",
    fontWeight: i = "normal",
    fontSize: o = 12,
    fontFamily: s = "Arial",
    lineHeight: r = 1
} = {}) {
    return` $ {
        t
    }
    $ {
        e
    }
    $ {
        i
    }
    $ {
        o
    }
    px / $ {
        r
    }
    $ {
        s
    }`
}
function Vf(t) {
    Lo(t)
}
export function slider(ctx, node){
    node.onMouseMove = dn;
    node.onMouseDown = dn;
    node.onValue = Vf;
    Hi(node),
    ctx.fillStyle = node.background,
    ctx.beginPath();
    let o = node.rect.x + node.barRect.x
      , s = node.rect.y + node.barRect.y
      , r = node.barRect.width
      , n = node.barRect.height
      , l = n / 2;
    ctx.moveTo(o + l, s),
    ctx.arcTo(o + r, s, o + r, s + n, l),
    ctx.arcTo(o + r, s + n, o, s + n, l),
    ctx.arcTo(o, s + n, node.rect.x, node.rect.y, l),
    ctx.arcTo(o, s, o + r, s, l),
    ctx.fill(),
    ctx.fillStyle = node.fillStyle,
    ctx.beginPath(),
    r = node.ballRect.x,
    ctx.moveTo(o + l, s),
    ctx.arcTo(o + r, s, o + r, s + n, l),
    ctx.arcTo(o + r, s + n, o, s + n, l),
    ctx.arcTo(o, s + n, node.rect.x, node.rect.y, l),
    ctx.arcTo(o, s, o + r, s, l),
    ctx.fill(),
    ctx.fillStyle = "#ffffff",
    ctx.beginPath(),
    o = node.rect.x + node.ballRect.x,
    s = node.rect.y + node.ballRect.y + node.ballRect.height / 2,
    ctx.lineWidth = node.ballRect.width / 10,
    ctx.arc(o, s, node.ballRect.width / 2, 0, Math.PI * 2),
    ctx.fill(),
    ctx.stroke()
}